export const CREATE_jwel = `${process.env.REACT_APP_jewl_SERVICE_URL}`;
export const CREATE_jwel1 = `${process.env.REACT_APP_tag_SERVICE_URL}`;
export const tenantName = localStorage.getItem("tenantName");
